import { ComponentRef, InjectionToken, Type } from '@angular/core';
import { BehaviorSubject, Observable, Subject, filter, firstValueFrom } from 'rxjs'
import { SopoDialogComponent } from '../components/sopo-dialog/sopo-dialog.component';

export class SopoDialogRef {
    private _closing = new BehaviorSubject(false);
    private readonly _afterClosed = new Subject<any>();
    private readonly _outAnimationDone = new Subject<boolean>();
    private _state: SopoDialogState = SopoDialogState.OPENED;
    private _insertedComponentRefSubject: BehaviorSubject<ComponentRef<SopoDialogComponent> | null> = new BehaviorSubject(null);
    closing = this._closing.asObservable();
    afterClosed: Observable<any> = this._afterClosed.asObservable();
    dialogComponentRef: ComponentRef<SopoDialogComponent>;
    doNotCloseOnClear = false;

    constructor() {}

    async close(result?: any) {
        this._state = SopoDialogState.CLOSED;
        this._closing.next(true);
        await firstValueFrom(this._outAnimationDone.asObservable().pipe(filter(value => value)));
        this._afterClosed.next(result);
    }

    outAnimationDone(): void {
        this._outAnimationDone.next(true);
    }

    getState(): SopoDialogState {
        return this._state;
    }

    set insertedComponentRef(componentRef: ComponentRef<any>) {
        if (this._insertedComponentRefSubject.value == null) this._insertedComponentRefSubject.next(componentRef);
    }

    async getInsertedComponentRef(): Promise<ComponentRef<any>> {
        const insertedComponentRef = await firstValueFrom(this._insertedComponentRefSubject.asObservable().pipe(
            filter(componentRef => componentRef != null)
        ))
        return insertedComponentRef;
    }
}

export const SOPO_DIALOG_DATA = new InjectionToken<any>('sopo-dialog-data');

export class SopoDialogSettings<D = any> {
    doNotCloseOnClear?: boolean;
    backdropDismiss?: boolean;
    width?: string;
    height?: string;
    maxHeight?: string;
    data?: D;
    closeButton?: boolean;
    sCss?: string[];
    zIndex?: number;
    disableScroll?: boolean;
    isGameContainer?: boolean;
    sideBetting?: boolean;
    insertedComponentType?: Type<any>;
}

export const DEFAULT_SOPO_DIALOG_SETTINGS: SopoDialogSettings = {
    doNotCloseOnClear: false,
    backdropDismiss: true,
    width: '',
    height: '',
    maxHeight: '',
    data: {},
    closeButton: false,
    sCss: [],
    zIndex: 0,
    disableScroll: false,
    isGameContainer: false,
    sideBetting: false,
}

export enum SopoDialogState {
    OPENED = 'OPENED',
    CLOSED = 'CLOSED',
}
